//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import classNames from 'classnames';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import styles from './index.module.scss';
//------------------------------------------------------------------------------
// Assets ----------------------------------------------------------------------
import {
  complianceIconUrl,
  revenueStreamIconUrl,
  simplifyOperationsIconUrl,
} from '@cmp/images';
import { withTranslation } from 'react-i18next';
//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------
class HowItWorks extends React.Component {
  constructor(props) {
    super(props);

    this.stepComponent = this.stepComponent.bind(this);
    this.steps = [
      {
        assetUrlFn: complianceIconUrl,
        titleI18nKey: 'landing_FindProducts',
        subtitleI18nKey: 'landing_FindProductsSubtitle',
        descriptionI18nKey: 'landing_FindProductsDescription',
      },
      {
        assetUrlFn: simplifyOperationsIconUrl,
        titleI18nKey: 'landing_SendRecommendations',
        subtitleI18nKey: 'landing_SendRecommendationsSubtitle',
        descriptionI18nKey: 'landing_SendRecommendationsDescription',
      },
      {
        assetUrlFn: revenueStreamIconUrl,
        titleI18nKey: 'landing_SeeSuccess',
        subtitleI18nKey: 'landing_SeeSuccessSubtitle',
        descriptionI18nKey: 'landing_SeeSuccessDescription',
      },
    ];
  }

  stepComponent(item, index) {
    const { withDescription, t, i18n } = this.props;
    const componentClasses = classNames(styles.Step, {
      [item.className]: item.className,
    });

    return (
      <div className={componentClasses} key={item.titleI18nKey}>
        <div className={styles.Illustration}>
          <img
            src={item.assetUrlFn(i18n)}
            alt={t(item.titleI18nKey)}
            className={styles.Image}
          />
          {!withDescription && (
            <span className={styles.Title}>{t(item.titleI18nKey)}</span>
          )}
          {!withDescription && (
            <span className={styles.Subtitle}>{t(item.subtitleI18nKey)}</span>
          )}
          {withDescription && (
            <span className={styles.Description}>
              {t(item.descriptionI18nKey)}
            </span>
          )}
        </div>
      </div>
    );
  }

  render() {
    const { className } = this.props;
    const componentClasses = classNames(styles.Steps, {
      [className]: className,
    });

    return (
      <div className={componentClasses}>
        {this.steps.map(this.stepComponent)}
      </div>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default withTranslation()(HowItWorks);
